import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function TargetAudienceSection() {
  const items = ['Abrís un programa de edición y no sabés qué tocar primero', 'Sentís que todo es muy técnico y terminás frustrado', 'Editás “a prueba y error” y dudás si lo que hacés está bien', 'Querés aprender a editar para trabajar remoto o generar ingresos', 'Querés videos más claros, profesionales y con intención', 'Necesitás editar videos para promover tu negocio o emprendimiento'];
  return <section className="py-16 md:py-24 bg-slate-900 px-4" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-146">
          Esto es para vos si…
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-147">
          {items.map((item, index) => <div key={index} className="flex items-start p-6 bg-slate-800 rounded-2xl border border-slate-700 hover:border-blue-500/50 transition-colors" data-id="element-148">
              <CheckCircle2 className="w-6 h-6 text-green-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-149" />
              <p className="text-slate-300 font-medium leading-relaxed" data-id="element-150">
                {item}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}